import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../config/API";

function BedBookingForUsers() {
  const navigate = useNavigate();
  const location = useLocation();

  // =====================================================
  // GET DATA FROM RegistrationForUsers
  // =====================================================

  const bookingData = location.state || {};

  // =====================================================
  // READ VALUES FROM PREVIOUS COMPONENT
  // =====================================================

  const userRegisterId = bookingData?.userRegisterId || "";

  const firstName = bookingData?.firstName || "";
  const lastName = bookingData?.lastName || "";

  // FLOOR
  const floorId = bookingData?.floorId || "";
  const floorName = bookingData?.floorName || "";

  // ROOM
  const roomId = bookingData?.roomId || "";
  const roomName = bookingData?.roomName || "";

  // BED
  const bedId = bookingData?.bedId || "";
  const bedName = bookingData?.bedName || "";

  // COST
  const bedCost = bookingData?.bedCost || "";

  // =====================================================
  // LOGGED-IN USER
  // =====================================================

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const userCreatedBy = user?.emailId || "";

  // =====================================================
  // STATES
  // =====================================================

  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);

  const [form, setForm] = useState({
    bedBookingType: "",
    snoringHabbit: "No",
  });

  // =====================================================
  // BOOKING TYPE
  // =====================================================

  const handleBookingTypeChange = (e) => {
    setForm((prev) => ({
      ...prev,
      bedBookingType: e.target.value,
    }));
  };

  // =====================================================
  // SNORING
  // =====================================================

  const handleSnoringChange = (e) => {
    setForm((prev) => ({
      ...prev,
      snoringHabbit: e.target.value,
    }));
  };

  // =====================================================
  // BOOK BED
  // =====================================================

  const handleBookBed = async () => {
    // -----------------------------------------------------
    // VALIDATION
    // -----------------------------------------------------

    if (!form.bedBookingType) {
      alert("Select Booking Type");
      return;
    }

    if (!userRegisterId) {
      alert("User Registration ID is missing");
      return;
    }

    if (!bedId) {
      alert("Bed ID is missing");
      return;
    }

    setLoading(true);

    // =====================================================
    // PAYLOAD
    // =====================================================

    const payload = {
      userRegisterId: userRegisterId,

      // FLOOR
      userFloorId: floorId,
      userFloorName: floorName,

      // ROOM
      userRoomId: roomId,
      userRoomName: roomName,

      // BED
      userBedId: bedId,
      userBedName: bedName,

      // COST
      bedCost: bedCost,

      // STATUS
      bedStatus: "BOOKED",

      // CREATED BY
      userCreatedBy: userCreatedBy,

      // BOOKING TYPE
      bedBookingType: form.bedBookingType,

      // SNORING
      snoringHabbit: form.snoringHabbit,
    };

    console.log("=================================");
    console.log("BED BOOKING PAYLOAD");
    console.log("=================================");
    console.log(payload);

    try {
      // =====================================================
      // API CALL
      // =====================================================

      const response = await fetch(`${API.V2}/user/bedBooking`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.jwtToken}`,
        },

        body: JSON.stringify(payload),
      });

      // =====================================================
      // RESPONSE
      // =====================================================

      const data = await response.json();

      console.log("=================================");
      console.log("BED BOOKING RESPONSE");
      console.log("=================================");
      console.log(data);

      // =====================================================
      // SUCCESS
      // =====================================================

      if (data?.statusCode === 200) {
        setShowPopup(true);

        setTimeout(() => {
          navigate("/userPaymentForm", {
            state: {
              userBookingId: data?.data?.userBookingId,

              firstName: firstName,

              lastName: lastName,

              totalBedCost: bedCost,
            },
          });
        }, 1500);

        return;
      }

      // =====================================================
      // API ERROR
      // =====================================================

      alert(data?.message || "Booking Failed ❌");
    } catch (error) {
      console.error("❌ BED BOOKING ERROR:", error);

      alert(error?.message || "Server Error. Unable to book the bed.");
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <div style={styles.container}>
      {/* =================================================
          SUCCESS POPUP
      ================================================= */}

      {showPopup && (
        <div style={styles.popupOverlay}>
          <div style={styles.popupBox}>
            <div style={styles.successIcon}>✅</div>

            <h2 style={styles.popupTitle}>Bed Booked Successfully</h2>

            <p style={styles.popupText}>Redirecting...</p>
          </div>
        </div>
      )}

      {/* =================================================
          MAIN CARD
      ================================================= */}

      <div style={styles.card}>
        <h1 style={styles.title}>🏠 Bed Booking For Users</h1>

        {/* =================================================
            BOOKING FORM
        ================================================= */}

        <div style={styles.grid}>
          {/* BOOKING TYPE */}

          <select
            value={form.bedBookingType}
            onChange={handleBookingTypeChange}
            style={styles.selectInput}
            disabled={loading}
          >
            <option value="">Select Booking Type</option>

            <option value="AdvanceBooking">Advance Booking</option>

            <option value="BookingNow">Booking Now</option>
          </select>

          {/* SNORING */}

          <div style={styles.radioBox}>
            <label style={styles.label}>Snoring Habit</label>

            <div style={{ marginTop: "10px" }}>
              <input
                type="radio"
                name="snoringHabbit"
                value="Yes"
                checked={form.snoringHabbit === "Yes"}
                onChange={handleSnoringChange}
                disabled={loading}
              />{" "}
              Yes
              <input
                type="radio"
                name="snoringHabbit"
                value="No"
                checked={form.snoringHabbit === "No"}
                onChange={handleSnoringChange}
                disabled={loading}
                style={{
                  marginLeft: 20,
                }}
              />{" "}
              No
            </div>
          </div>

          {/* FLOOR */}

          <input
            type="text"
            value={floorName}
            readOnly
            placeholder="Floor Name"
            style={styles.floorInput}
          />

          {/* ROOM */}

          <input
            type="text"
            value={roomName}
            readOnly
            placeholder="Room Name"
            style={styles.roomInput}
          />

          {/* BED */}

          <input
            type="text"
            value={bedName}
            readOnly
            placeholder="Bed Name"
            style={styles.bedInput}
          />

          {/* COST */}

          <input
            type="text"
            value={bedCost ? `₹ ${bedCost}` : ""}
            readOnly
            placeholder="Bed Cost"
            style={styles.costInput}
          />
        </div>

        {/* =================================================
            SUMMARY
        ================================================= */}

        <div style={styles.summaryContainer}>
          {/* FLOOR */}

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>🏢 Floor</h3>

            <p style={styles.summaryText}>{floorName || "N/A"}</p>
          </div>

          {/* ROOM */}

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>🚪 Room</h3>

            <p style={styles.summaryText}>{roomName || "N/A"}</p>
          </div>

          {/* BED */}

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>🛏 Bed</h3>

            <p style={styles.summaryText}>{bedName || "N/A"}</p>
          </div>

          {/* COST */}

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>💰 Cost</h3>

            <p style={styles.summaryText}>₹ {bedCost || 0}</p>
          </div>
        </div>

        {/* =================================================
            BOOK BUTTON
        ================================================= */}

        <button
          style={{
            ...styles.bookBtn,

            opacity: loading ? 0.6 : 1,

            cursor: loading ? "not-allowed" : "pointer",
          }}
          onClick={handleBookBed}
          disabled={loading}
        >
          {loading ? "Booking..." : "🛏 Book Bed"}
        </button>
      </div>
    </div>
  );
}

export default BedBookingForUsers;

// =====================================================
// STYLES
// =====================================================

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#dbeafe,#f8fafc,#e0f2fe)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px",
    fontFamily: "Segoe UI, sans-serif",
    boxSizing: "border-box",
  },

  card: {
    width: "100%",
    maxWidth: "1150px",
    background: "#ffffff",
    borderRadius: "24px",
    padding: "40px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
    boxSizing: "border-box",
  },

  title: {
    textAlign: "center",
    fontSize: "38px",
    fontWeight: "bold",
    marginBottom: "35px",
    color: "#0f172a",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: "20px",
  },

  selectInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #93c5fd",
    background: "#dbeafe",
    fontSize: "15px",
    fontWeight: "600",
    outline: "none",
  },

  radioBox: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #cbd5e1",
    background: "#f8fafc",
  },

  label: {
    fontWeight: "700",
    color: "#1e293b",
  },

  floorInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #93c5fd",
    background: "#dbeafe",
    fontSize: "15px",
    fontWeight: "700",
    color: "#1e3a8a",
    outline: "none",
  },

  roomInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #86efac",
    background: "#dcfce7",
    fontSize: "15px",
    fontWeight: "700",
    color: "#166534",
    outline: "none",
  },

  bedInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #d8b4fe",
    background: "#f3e8ff",
    fontSize: "15px",
    fontWeight: "700",
    color: "#6b21a8",
    outline: "none",
  },

  costInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #fdba74",
    background: "#ffedd5",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#ea580c",
    outline: "none",
  },

  summaryContainer: {
    marginTop: "35px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: "20px",
  },

  summaryCard: {
    background: "linear-gradient(135deg,#2563eb,#06b6d4)",
    color: "#fff",
    borderRadius: "18px",
    padding: "25px",
    textAlign: "center",
    fontWeight: "bold",
  },

  summaryTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },

  summaryText: {
    fontSize: "16px",
  },

  bookBtn: {
    width: "100%",
    marginTop: "25px",
    padding: "18px",
    border: "none",
    borderRadius: "16px",
    background: "linear-gradient(45deg,#4f46e5,#06b6d4)",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
  },

  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
  },

  popupBox: {
    width: "380px",
    background: "#fff",
    borderRadius: "24px",
    padding: "40px 30px",
    textAlign: "center",
    boxSizing: "border-box",
  },

  successIcon: {
    fontSize: "70px",
    marginBottom: "20px",
  },

  popupTitle: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "bold",
    color: "#16a34a",
  },

  popupText: {
    marginTop: "12px",
    fontSize: "16px",
    color: "#475569",
    fontWeight: "500",
  },
};
